import { Camera, Sun, Square, Layers, Ruler, Sparkles, Check, Loader2 } from "lucide-react";

const TIPS = [
  { icon: Sun, t: "Daylight, no flash", d: "Shoot by a window. Flash flattens colour and adds glare." },
  { icon: Square, t: "Plain background", d: "A white wall, a bedsheet or a clean table. Let the product be the hero." },
  { icon: Layers, t: "Fill the frame", d: "Get close. The product should take up most of the photo." },
  { icon: Ruler, t: "Show the scale", d: "One shot in use or next to something familiar builds trust." },
  { icon: Camera, t: "Sharp and straight", d: "Wipe your lens, hold still, keep the horizon level." },
];

export function FirstListingGuide({ hasPhoto, hasTitle, hasPrice, describing, described }) {
  const steps = [
    { n: 1, label: "Add a photo", done: hasPhoto },
    { n: 2, label: "AI writes your listing", done: described, busy: describing },
    { n: 3, label: "Set a price & publish", done: hasPrice && hasTitle },
  ];
  const current = steps.findIndex((s) => !s.done);
  return (
    <section className="mt-6 rounded-2xl border border-[#FF3B30]/30 bg-gradient-to-br from-[#1a0b0b] via-[#121212] to-[#0a0a0a] p-5 sm:p-6" data-testid="first-listing-guide">
      <div className="text-[10px] uppercase tracking-[0.25em] text-[#FF3B30]">Your first listing · 3 minutes</div>
      <h2 className="mt-1 text-base md:text-lg font-black tracking-tight text-white">Great photo in → finished listing out</h2>
      <ol className="mt-4 grid sm:grid-cols-3 gap-2" data-testid="first-listing-steps">
        {steps.map((s, i) => (
          <li key={s.n} data-testid={`first-listing-step-${s.n}`} data-state={s.done ? "done" : i === current ? "current" : "todo"}
            className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 transition-colors ${s.done ? "border-[#34C759]/40 bg-[#34C759]/10" : i === current ? "border-white/30 bg-white/[0.06]" : "border-white/10 bg-black/20"}`}>
            <span className={`h-7 w-7 shrink-0 rounded-full grid place-items-center text-xs font-black ${s.done ? "bg-[#34C759] text-black" : i === current ? "bg-white text-black" : "bg-white/10 text-neutral-400"}`}>
              {s.busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : s.done ? <Check className="h-3.5 w-3.5" /> : s.n}
            </span>
            <span className={`text-sm font-semibold ${s.done || i === current ? "text-white" : "text-neutral-500"}`}>{s.label}</span>
          </li>
        ))}
      </ol>
      {!hasPhoto && (
        <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-5 gap-2" data-testid="photo-tips">
          {TIPS.map(({ icon: Icon, t, d }) => (
            <div key={t} className="rounded-xl border border-white/10 bg-black/30 p-3">
              <Icon className="h-4 w-4 text-[#FF9F0A]" />
              <div className="mt-2 text-xs font-bold text-white">{t}</div>
              <div className="mt-0.5 text-[11px] leading-snug text-neutral-400">{d}</div>
            </div>
          ))}
        </div>
      )}
      {hasPhoto && (
        <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#007AFF]/40 bg-[#007AFF]/10 px-3 py-1.5 text-xs text-[#9fd0ff]" data-testid="first-listing-ai-status">
          <Sparkles className="h-3.5 w-3.5" />
          {describing ? "Gemini is looking at your photo and writing the title, description, category and tags…" : described ? "Listing written from your photo — tweak anything, then set your price." : "Photo ready. Tap “AI fill” to write the listing."}
        </div>
      )}
    </section>
  );
}
